(() => {
  'use strict';

  const privacyPath = '/pages/politique-de-confidentialite';
  const policySelector = '#shopify-pc__banner__body-policy-link';
  const manageSelector = '#shopify-pc__banner__btn-manage-prefs';

  const getPrivacyBannerApi = () => {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return window.privacyBanner;
    }
    try {
      if (typeof privacyBanner !== 'undefined' && typeof privacyBanner.showPreferences === 'function') {
        return privacyBanner;
      }
    } catch (_) {
      /* Le module natif n’est pas encore disponible. */
    }
    return null;
  };

  const normalizePolicyLink = (root = document) => {
    const links = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.(policySelector)) links.push(root);
    if (root.querySelectorAll) links.push(...root.querySelectorAll(policySelector));

    links.forEach((link) => {
      link.setAttribute('href', privacyPath);
      link.setAttribute('target', '_self');
      link.removeAttribute('data-sanitized-target');
      link.removeAttribute('rel');
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const policyLink = target.closest(policySelector);
    if (policyLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(privacyPath);
      return;
    }

    const manageButton = target.closest(manageSelector);
    if (!manageButton) return;

    const api = getPrivacyBannerApi();
    if (!api) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    api.showPreferences().catch(() => {
      /* Si l’API est momentanément indisponible, le prochain clic est retenté. */
    });
  }, true);

  normalizePolicyLink();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => normalizePolicyLink(node));
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
